/** @format */
import React from 'react'

export default function FileListTable({ processedFiles, unprocessedFiles }) {
    return (
        <div
            style={{
                maxHeight: '70vh',
                overflowY: 'auto',
                position: 'relative',
            }}
        >
            <table className="table table-condensed table-hover">
                <thead>
                    <tr>
                        <th
                            style={{
                                position: 'sticky',
                                top: 0,
                                backgroundColor: '#FFFFFF',
                            }}
                        >
                            Filename
                        </th>
                        <th
                            style={{
                                position: 'sticky',
                                top: 0,
                                backgroundColor: '#FFFFFF',
                            }}
                        >
                            Processed?
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {processedFiles.map((filename) => (
                        <tr className="active" key={filename}>
                            <td>{filename}</td>
                            <td>Yes</td>
                        </tr>
                    ))}
                    {unprocessedFiles.map((filename) => (
                        <tr key={filename}>
                            <td>{filename}</td>
                            <td>No</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}



// WEBPACK FOOTER //
// ./app/pages/FergusLogs/SupplierDocuments/FileListTable.js